export default __webpack_public_path__ + "media/images/icons/fill-drip-solid-0f8ba2d2073f94fcaccdee6283ea9274.svg";